// extracted by mini-css-extract-plugin
export default {"pageContent":"PageContent_pageContent__Fp6o2","mobile":"PageContent_mobile__CmQeU","container":"PageContent_container__H+ACT"};